import {Box,Grid,Button,Paper,MenuItem,TextField,Breadcrumbs,Link,Typography,Menu} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useItemSaleSummativeReportList } from "api/hooks/reports";
import { useSelector } from "react-redux";
import { useState } from "react";
import moment from "moment";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DownloadIcon from "@mui/icons-material/Download";
import ReportTable, { RRow, RCell } from "components/Tables/ReportTable";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ItemSalesSummativeReportPdf from "scenes/reports/pdfForms/sales/itemSalesSummativeReportPdf";
import { currencyFormatter } from "utilities/currencyFormatter";

export default function ItemSalesSummativeReport({ setIsSuccess }) {
  const navigate = useNavigate();
  const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
  const user = useSelector((state) => state.authReducer.user);
  const {itemSaleSummativeReportList, isLoadingItemSaleSummativeReportList, setFilter, setListOrdering, setOrderParameter} = useItemSaleSummativeReportList(1, business_branch_id)
  const [openExportOptions, setOpenExportOptions] = useState(false);
  const [anchorE1, setAnchorE1] = useState(null);

  const handleClickOpen = (event) => {
    setAnchorE1(event.currentTarget);
    setOpenExportOptions(true);
  };

  const handleClose = () => {
    setOpenExportOptions(false);
  };
  const [showFilter, setShowFilter] = useState(false);
  const [parameter, setParameter] = useState('invoice_amount');
  const [ordering, setOrdering] = useState('DESCENDIN');
  const [startDate, setStartDate] = useState(moment().startOf("month").format("YYYY-MM-DD HH:mm"));
  const [endDate, setEndDate] = useState(moment().endOf("month").format("YYYY-MM-DD HH:mm"));

  let report_period = startDate + " to " + endDate

  const handleChangePeriodFilter = async (e) => {
    if (e.target.value === "THIS MONTH") {
      setStartDate(moment().startOf("month").format("YYYY-MM-DD HH:mm"));
      setEndDate(moment().endOf("month").format("YYYY-MM-DD HH:mm"));
      setShowFilter(false);
    }
    if (e.target.value === "THIS WEEK") {
      setStartDate(moment().startOf("week").format("YYYY-MM-DD HH:mm"));
      setEndDate(moment().endOf("week").format("YYYY-MM-DD HH:mm"));
      setShowFilter(false);
    }
    if (e.target.value === "TODAY") {
      setStartDate(moment().format("YYYY-MM-DD HH:mm"));
      setEndDate(moment().format("YYYY-MM-DD HH:mm"));
      setShowFilter(false);
    }
    if (e.target.value === "CUSTOM") {
      setShowFilter(true);
    }
  };

  const handleClickFilter = () => {
    setFilter({ start: startDate, end: endDate });
  };

  const handleClickOrder = ()=> {
    setOrderParameter(parameter);
    setListOrdering(ordering);
  }

  const columns = [
    { label: "Item", width: 300 },
    { label: "Description", width: 300 },
    { label: "Total Sale Quantity", align: "center" },
    { label: "Unit" },
    { label: "Total Sale Price", align: "center" },
    { label: "Total Discount", align: "center" },
  ];

  return (
    <Box>
      <Breadcrumbs sx={{ padding: "20px" }} aria-label="breadcrumb">
        <Link
          underline="hover"
          sx={{ display: "flex", alignItems: "center" }}
          color="inherit"
          // onClick={() => navigate("/reports")}
          onClick={() => navigate("/reports")}
        >
          <AssessmentIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Reports
        </Link>
        <Typography
          sx={{ display: "flex", alignItems: "center" }}
          color="text.primary"
        >
          <b>Item Sales Summative Report</b>
        </Typography>
      </Breadcrumbs>
      <Box>
        <Box p="1rem" m="1rem" borderRadius="0.5rem">
          <Grid container spacing={4} className="alignHorizantal">
            <Grid xs={6}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems:"center"
                  // m: "4px",
                }}
              >
                <h4>REPORT PERIOD:</h4>

                <Paper
                  sx={{
                    m: "10px",
                    display: "flex",
                    alignItems: "center",
                    minWidth: 130,
                    maxWidth: 200,
                    height: "37px",
                  }}
                >
                  <TextField
                    label="PERIOD"
                    select
                    defaultValue="THIS MONTH"
                    size="small"
                    onChange={(e) => {
                      handleChangePeriodFilter(e);
                    }}
                    sx={{
                      minWidth: 50,
                      width: "100%",
                      // m: "10px",
                      // backgroundColor: "white",
                    }}
                  >
                    <MenuItem value="TODAY">TODAY</MenuItem>
                    <MenuItem value="THIS WEEK">THIS WEEK</MenuItem>
                    <MenuItem value="THIS MONTH">THIS MONTH</MenuItem>
                    <MenuItem value="CUSTOM">CUSTOM</MenuItem>
                  </TextField>
                </Paper>

                {showFilter ? (
                  <>
                    <Paper
                      sx={{
                        m: "0 5px",
                        display: "flex",
                        alignItems: "center",
                        minWidth: 130,
                        maxWidth: 200,
                        height: "37px",
                      }}
                    >
                      <TextField
                        label="Start Date"
                        type="datetime-local"
                        defaultValue={startDate}
                        size="small"
                        onChange={(e) => setStartDate(e.target.value)}
                        // sx={{
                        //   m: "0 5px",
                        //   backgroundColor: "white",
                        // }}
                        inputProps={{
                          max: endDate,
                        }}
                      />
                    </Paper>

                    <Paper
                      sx={{
                        m: "0 5px",
                        display: "flex",
                        alignItems: "center",
                        minWidth: 130,
                        maxWidth: 200,
                        height: "37px",
                      }}
                    >
                      <TextField
                        label="End Date"
                        type="datetime-local"
                        defaultValue={endDate}
                        size="small"
                        onChange={(e) => setEndDate(e.target.value)}
                        // sx={{
                        //   m: "10px",
                        //   backgroundColor: "white",
                        // }}
                        inputProps={{
                          min: startDate,
                        }}
                      />
                    </Paper>
                  </>
                ) : null}
                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    m: "9px",
                  }}
                  onClick={() => handleClickFilter()}
                >
                  FILTER
                </Button>
              </Box>
            </Grid>

            <Grid xs={4}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems:"center"
                  // m: "4px",
                }}
              >
                <h4>ORDER BY:</h4>

                <Paper
                  sx={{
                    m: "10px",
                    display: "flex",
                    alignItems: "center",
                    minWidth: 130,
                    maxWidth: 200,
                    height: "37px",
                  }}
                >
                  <TextField
                    label="ORDER PARAMETER"
                    select
                    defaultValue="invoice_amount"
                    size="small"
                    onChange={(e) => setParameter(e.target.value)}
                    sx={{
                      minWidth: 50,
                      width: "100%",
                      // m: "10px",
                      // backgroundColor: "white",
                    }}
                  >
                    <MenuItem value="invoice_amount">SALES PRICE</MenuItem>
                    <MenuItem value="quantity_invoiced">
                      SALES QUANTITY
                    </MenuItem>
                    <MenuItem value="profit">PROFITS</MenuItem>
                  </TextField>
                </Paper>

                <Paper
                  sx={{
                    m: "10px",
                    display: "flex",
                    alignItems: "center",
                    minWidth: 130,
                    maxWidth: 200,
                    height: "37px",
                  }}
                >
                  <TextField
                    label="ORDER"
                    select
                    defaultValue="DESCENDING"
                    size="small"
                    onChange={(e) => setOrdering(e.target.value)}
                    sx={{
                      minWidth: 50,
                      width: "100%",
                      // m: "10px",
                      // backgroundColor: "white",
                    }}
                  >
                    <MenuItem value="DESCENDING">DESCENDING</MenuItem>
                    <MenuItem value="ASCENDING">ASCENDING</MenuItem>
                  </TextField>
                </Paper>
                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    m: "9px",
                  }}
                  onClick={() => handleClickOrder()}
                >
                  ORDER
                </Button>
              </Box>
            </Grid>
            <Grid xs={2} sx={{ textAlign: "right" }}>
              <Button
                variant="contained"
                onClick={handleClickOpen}
                anchorE1={anchorE1}
                endIcon={<DownloadIcon />}
              >
                EXPORT
              </Button>
              <Menu
                style={{ marginRight: "30px" }}
                anchorEl={anchorE1}
                open={openExportOptions}
                onClose={handleClose}
              >
                <MenuItem
                  style={{
                    color: "black",
                    margin: "5px 0 5px 0",
                    fontSize: "12px",
                    width: "100px",
                    textWrap: "pretty",
                    borderRadius: "5px",
                  }}
                  onClick={() => {
                    handleClose();
                  }}
                >
                  <PDFDownloadLink
                    document={
                      <ItemSalesSummativeReportPdf
                        viewData={{
                          report_detail: itemSaleSummativeReportList,
                          report_period: report_period,
                        }}
                        printedBy={user.first_name + " " + user.last_name}
                      />
                    }
                    fileName={`Item Sales Summative Report for ${report_period}`}
                  >
                    PDF
                  </PDFDownloadLink>
                </MenuItem>
                <MenuItem
                  style={{
                    color: "black",
                    margin: "5px 0 5px 0",
                    fontSize: "12px",
                    width: "100px",
                    textWrap: "pretty",
                    borderRadius: "5px",
                  }}
                  onClick={() => {
                    handleClose();
                  }}
                >
                  EXCEL
                </MenuItem>
              </Menu>
            </Grid>
          </Grid>
        </Box>

        <ReportTable
          columns={columns}
          rows={itemSaleSummativeReportList}
          loading={isLoadingItemSaleSummativeReportList}
          emptyMessage="No data found"
          renderRow={(row, index) => (
            <RRow key={row.id ?? index} index={index}>
              <RCell>{row.product_name}</RCell>
              <RCell>{row.description}</RCell>
              <RCell align="center">{row.quantity_invoiced}</RCell>
              <RCell>{row.unit}</RCell>
              <RCell align="center">{currencyFormatter(parseFloat(Number(row.invoice_amount)))}</RCell>
              <RCell align="center">{currencyFormatter(parseFloat(Number(row.invoice_discount)))}</RCell>
            </RRow>
          )}
        />
      </Box>
    </Box>
  );
}
